import { primaryColor } from "assets/jss/material-dashboard-pro-react";

const wrapperStyle = (theme) => ({
	infoMessageContainer: {
		width: '98%',
		margin: '20px 0 0 13px',
		backgroundColor: (props) => props.backgroundColor,
		display: 'flex',
		padding: '11px 0 4px 8px',
	},
	infoiconWrapper: {
		display: 'flex',
	},
	infoicon: {
		transform: 'rotate(180deg)',
	},
	messageWrapper: {
		display: 'flex',
		flexGrow: '1',
		marginLeft: '10px',
	},
	closeButton: {
		cursor: 'pointer',
		marginRight: '10px',
	},
	link: {
		fontFamily: theme.fontFamily.albert.regular,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: 'normal',
		fontSize: theme.fontSize(16),
		lineHeight: theme.fontSize(22),
		margin: '1px 0 0 5px',
		textDecoration: 'underline',
	},
	bannerLink: {
		cursor:'pointer',
		color: `${primaryColor[0]} !important`
	}
});

export default wrapperStyle;
